(() => {
  const companyId = 'VGkYU8';
  const smsList = 'S9Se4A';
  window.instameInStoreSaveContact = async ({ api, headers, customer, marketing }) => {
    const profile = await fetch(`${api}/api/in-store/customer`, {
      method: 'POST',
      headers: { ...headers, 'Content-Type': 'application/json' },
      body: JSON.stringify({ customer, marketing }),
    });
    if (!profile.ok) throw new Error('Customer profile could not be saved.');
    if (!marketing) return { profileSaved: true, marketingRequested: false };
    const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${companyId}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2026-04-15' },
      body: JSON.stringify({ data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Hillsdale in-store',
          profile: { data: { type: 'profile', attributes: {
            phone_number: customer.phone,
            first_name: customer.name,
            subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } },
          } } },
        },
        relationships: { list: { data: { type: 'list', id: smsList } } },
      } }),
    });
    if (!response.ok) throw new Error('Marketing confirmation could not be requested.');
    // Accepted is not subscribed: the existing list requires SMS confirmation.
    return { profileSaved: true, marketingRequested: true };
  };
})();
